import Facebook from '@mui/icons-material/Facebook';
import Instagram from '@mui/icons-material/Instagram';
import Twitter from '@mui/icons-material/Twitter';
import YouTube from '@mui/icons-material/YouTube';
import { Grid, Link, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Layout from '../components/Layout';
import ConfigContext from '../context/config';
import useNonNullContext from '../hooks/useNonNullContext';

export default function Custom404() {
  const tenant = useNonNullContext(ConfigContext);
  const socialLinks = tenant.footer.contactInfoSection.socialLinks || [];

  const theme = useTheme();
  const color = theme.palette.common.black;

  return (
    <Layout
      cssOverrides={{
        backgroundSize: 'cover',
        backgroundPosition: 'center bottom',
        height: '100vh',
        backgroundImage:
          "url('https://territory-assets.s3.amazonaws.com/static/error_pages/404bgImage@2x.jpg')",
      }}
    >
      <Grid
        container
        direction={'column'}
        sx={{ textAlign: 'center', alignItems: 'center' }}
      >
        <Typography variant={'h2'} sx={{ marginTop: '5rem' }}>
          Well, this is weird
        </Typography>
        <Typography variant={'body1'} sx={{ marginBottom: '2rem' }}>
          We can&apos;t find this page, but you just found yourself some share
          buttons.
        </Typography>
        <Grid container direction={'row'} justifyContent={'center'}>
          {socialLinks?.map((socialLink) => {
            return (
              <Link
                key={socialLink.hrefUrl}
                href={socialLink.hrefUrl}
                className="social-link"
                color={color}
                sx={{ padding: '0.5rem' }}
              >
                {socialLink.logoAssetUrl === 'Facebook' && <Facebook />}
                {socialLink.logoAssetUrl === 'Instagram' && <Instagram />}
                {socialLink.logoAssetUrl === 'Twitter' && <Twitter />}
                {socialLink.logoAssetUrl === 'YouTube' && <YouTube />}
              </Link>
            );
          })}
        </Grid>
      </Grid>
    </Layout>
  );
}
